import i18n from 'constants/translation/i18n';

const whoAmIWorkflow = (t?: any) => {
  const entries = [
    {
      area: 'Allocation',
      title: t ? t('ALLOCATION_TITLE') : i18n.t('ALLOCATION_TITLE'),
      href: '/who_am_i/allocation'
    },
    {
      area: 'Allocation_of_persons',
      title: t ? t('ALLOCATION_PERSONS') : i18n.t('ALLOCATION_PERSONS'),
      href: '/who_am_i/allocation/persons'
    }
  ];
  return entries;
};

export default whoAmIWorkflow;
